import React from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { tours } from '../data/tourData'; // Importa los datos de los tours
import '../styles/TourSlider.css';
import TitleSubtitle from './TitleSubtitle';
import TourSliderCard from './TourSliderCard';

const TourSlider = ({ title, idTourExcluido }) => {
  return (
    <section className="tour-slider-section">
      <TitleSubtitle title={title} position="centro" />
      <Swiper
        spaceBetween={20}
        slidesPerView={4}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        loop={true}
        modules={[Navigation, Pagination, Autoplay]}
        breakpoints={{
          1024: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          810: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          0: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        }}
        className="tour-slider"
      >
        {tours.filter((paquete) => paquete.id !== idTourExcluido).map((tour) => (
          <SwiperSlide key={tour.id}>
              <TourSliderCard key={tour.id} data={tour} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default TourSlider;
